import { FC, ReactNode } from 'react';
import classnames from 'classnames';
import { GridCol, GridRow } from 'dibs-elements/exports/Grid';
import styles from './styles/CheckoutMobileSection.scss';

type CheckoutMobileSectionProps = {
    className?: string;
    children: ReactNode;
};

export const CheckoutMobileSection: FC<CheckoutMobileSectionProps> = props => {
    const { className, children } = props;

    return (
        <div className={classnames(styles.section, className)}>
            <GridRow>
                <GridCol
                    desktopOptions={{ offset: 2 }}
                    tabletLandscapeOptions={{ offset: 2 }}
                    tabletPortraitOptions={{ offset: 2 }}
                    mobile={12}
                    desktop={8}
                >
                    {children}
                </GridCol>
            </GridRow>
        </div>
    );
};
